$(document).ready(() => {
    const recruiterReviewsDataTable = $('#recruiterReviewsDataTable');
    const reviewForm = $('#entity-review');
    // Reset the form after modal closes
    $('#writeReview').on('hidden.bs.modal', () => {
        reviewForm[0].reset();
        reviewForm.parsley().reset();
    });

    recruiterReviewsDataTable.DataTable({
        language: {
            emptyTable: 'Be the first to add a review!',
            zeroRecords: 'Be the first to add a review!',
        },
        paging: true,
        bInfo: false,
        bFilter: false,
        ordering: false,
        pageLength: 5,
        lengthChange: false,
        search: false,
        ajax: {
            url: recruiterReviewsDataTable.data('source'),
        },
        columns: [
            {
                name: 'markup',
                data: 'markup',
            },
        ],
    });
});
